const MicrotaskDelay = Symbol('MicrotaskDelay');
export { MicrotaskDelay };
